export default __webpack_public_path__ + "static/media/gb.ad3aa4f8.svg";